import React, { useContext, useState } from 'react';
import ResultItem, { LocationImage } from '../ResultItem';
import { nearMeUrl } from '../../utils';
import AppContext from '../../../../../context';
import DiscoveryContext from '../../../../../contexts/discoveryContext/context';
import { ContextName } from '../../../../../appContext/contextName';
import { AccuracyEnum } from '../../../../../appContext/location';
import { getBrowserLocation } from '../../../../../appContext/LocationProvider';
import history from '@/routes/routes/helpers/history';

const NearMeItem = ({ countryCode, onClick: trackingOnClick = () => {} }) => {
  const {
    [ContextName.LOCATION.LATITUDE]: latitude,
    [ContextName.LOCATION.LONGITUDE]: longitude,
    [ContextName.LOCATION.NAME]: locationName,
    [ContextName.LOCATION.ACCURACY]: locationAccuracy,
    [ContextName.LOCATION.UPDATE_COORDS]: updateCoords,
    [ContextName.LOCATION.UPDATE_NAME]: updateLocationName,
    [ContextName.LOCATION.BROWSER_GEO_QUERYABLE]: browserGeoQueryable,
    [ContextName.LOCATION
      .UPDATE_BROWSER_GEO_QUERYABLE]: updateBrowserGeoQueryable,
  } = useContext(AppContext);
  const [isLoadingGeo, setIsLoadingGeo] = useState(false);

  const { searchParams, currentPath: lastTagPath } = useContext(
    DiscoveryContext,
  );
  if (!browserGeoQueryable || !latitude || !longitude) {
    return null;
  }

  const permalink = nearMeUrl({
    countryCode,
    latitude,
    longitude,
    locationName,
    searchParams,
    tagPath: lastTagPath,
  }).url;

  const shouldShowLocationName =
    locationName && locationAccuracy === AccuracyEnum.BROWSER;

  const title = isLoadingGeo
    ? 'Loading...'
    : `Near me${shouldShowLocationName ? ` in ${locationName}` : ''}`;

  const itemOnClick = async (e) => {
    if (locationAccuracy !== AccuracyEnum.BROWSER) {
      e.preventDefault();
      try {
        setIsLoadingGeo(true);

        const {
          locationName: updatedLocationName,
          latitude: updatedLatitude,
          longitude: updatedLongitude,
          accuracy,
        } = await getBrowserLocation();

        updateCoords({ latitude: null, longitude: null });
        updateCoords({
          latitude: updatedLatitude,
          longitude: updatedLongitude,
          accuracy,
        });
        updateLocationName({ locationName: updatedLocationName });

        const { path, search } = nearMeUrl({
          countryCode,
          latitude: updatedLatitude,
          longitude: updatedLongitude,
          locationName: updatedLocationName,
          searchParams,
          tagPath: lastTagPath,
        });

        history.push({
          pathname: path,
          search,
        });
      } catch {
        setIsLoadingGeo(false);
        updateBrowserGeoQueryable(false);
      }
    }

    trackingOnClick({
      latitude,
      longitude,
      locationName,
      permalink,
      title,
    });
  };

  return (
    <ResultItem
      image={LocationImage()}
      permalink={permalink}
      title={title}
      onClick={itemOnClick}
    />
  );
};

export default NearMeItem;
